export default "__VITE_ASSET__ZZ0cbA2M__"